import { Link } from 'react-router-dom';
import { Button } from '@/components/ui';
import { Logo } from '@/components/brand/Logo';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-canvas px-6 text-center">
      <Logo size="lg" />
      <div>
        <p className="font-mono text-xs uppercase tracking-widest text-ink-faint">Error 404</p>
        <h1 className="mt-2 font-display text-5xl font-semibold tracking-tight">
          This page moved — or never existed.
        </h1>
        <p className="mx-auto mt-3 max-w-md font-editorial text-lg italic text-ink-muted">
          Let's get you back to solid ground.
        </p>
      </div>
      <Link to="/">
        <Button variant="primary">Back to home</Button>
      </Link>
    </div>
  );
}
